import { __decorate, __param } from 'tslib';
import { Directive, ElementRef, Inject, Input, HostBinding, HostListener, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TUI_SCROLL_REF } from '@taiga-ui/core/tokens';
import { TUI_SCROLLABLE, TUI_SCROLL_INTO_VIEW } from '@taiga-ui/core/constants';
import { CSS, USER_AGENT } from '@ng-web-apis/common';
import { isFirefox, getElementOffset, TUI_IS_IOS, tuiDefaultProp } from '@taiga-ui/cdk';
import { CommonModule } from '@angular/common';
import { TuiScrollControlsModule } from '@taiga-ui/core/components/scroll-controls';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/scroll-controls';

function TuiScrollbarComponent_tui_scroll_controls_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-scroll-controls");
} }
const _c0 = ["*"];
const SCROLL_REF_SELECTOR = '[tuiScrollRef]';
let TuiScrollRefDirective = class TuiScrollRefDirective {
};
TuiScrollRefDirective.ɵfac = function TuiScrollRefDirective_Factory(t) { return new (t || TuiScrollRefDirective)(); };
TuiScrollRefDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiScrollRefDirective, selectors: [["", "tuiScrollRef", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_SCROLL_REF,
                useExisting: ElementRef
            },
        ])] });

let TuiScrollableDirective = class TuiScrollableDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.elementRef.nativeElement.dispatchEvent(new CustomEvent(TUI_SCROLLABLE, {
            bubbles: true,
            detail: this.elementRef.nativeElement,
        }));
    }
};
TuiScrollableDirective.ɵfac = function TuiScrollableDirective_Factory(t) { return new (t || TuiScrollableDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
TuiScrollableDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiScrollableDirective, selectors: [["", "tuiScrollable", ""]] });
TuiScrollableDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] }
];
TuiScrollableDirective = __decorate([ __param(0, Inject(ElementRef))
], TuiScrollableDirective);

var TuiScrollbarComponent_1;
function scrollRefFactory({ browserScrollRef, }) {
    return browserScrollRef;
}
// @dynamic
let TuiScrollbarComponent = TuiScrollbarComponent_1 = class TuiScrollbarComponent {
    constructor(
    /**
     * TODO: remove "any" in new TS version; https://github.com/ng-web-apis/common/pull/6
     */
    cssRef, elementRef, userAgent, isIos) {
        this.cssRef = cssRef;
        this.elementRef = elementRef;
        this.userAgent = userAgent;
        this.isIos = isIos;
        this.delegated = false;
        this.isLegacy = !this.cssRef.supports('position', 'sticky') ||
            (isFirefox(this.userAgent) && !this.cssRef.supports('scrollbar-width', 'none'));
        this.hidden = false;
        this.browserScrollRef = new ElementRef(this.elementRef.nativeElement);
    }
    get showScrollbars() {
        return !this.hidden && !this.isIos && (!this.isLegacy || this.delegated);
    }
    get showNative() {
        return this.isLegacy && !this.hidden && !this.delegated;
    }
    onScrollable(element) {
        this.delegated = true;
        this.browserScrollRef.nativeElement = element;
    }
    scrollIntoView(detail) {
        if (this.delegated) {
            return;
        }
        const { nativeElement } = this.browserScrollRef;
        const { offsetTop, offsetLeft } = getElementOffset(nativeElement, detail);
        nativeElement.scrollTop =
            offsetTop + detail.offsetHeight / 2 - nativeElement.clientHeight / 2;
        nativeElement.scrollLeft =
            offsetLeft + detail.offsetWidth / 2 - nativeElement.clientWidth / 2;
    }
};
TuiScrollbarComponent.ɵfac = function TuiScrollbarComponent_Factory(t) { return new (t || TuiScrollbarComponent)(ɵngcc0.ɵɵdirectiveInject(CSS), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(USER_AGENT), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS)); };
TuiScrollbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiScrollbarComponent, selectors: [["tui-scrollbar"]], hostVars: 2, hostBindings: function TuiScrollbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("tui-scrollable.stop", function TuiScrollbarComponent_tui_scrollable_stop_HostBindingHandler($event) { return ctx.onScrollable($event.detail); })("tui-scroll-into-view.stop", function TuiScrollbarComponent_tui_scroll_into_view_stop_HostBindingHandler($event) { return ctx.scrollIntoView($event.detail); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_legacy", ctx.showNative);
    } }, inputs: { hidden: "hidden" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_SCROLL_REF,
                deps: [TuiScrollbarComponent_1],
                useFactory: scrollRefFactory
            },
        ])], ngContentSelectors: _c0, decls: 3, vars: 1, consts: [[4, "ngIf"], [1, "content"]], template: function TuiScrollbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiScrollbarComponent_tui_scroll_controls_0_Template, 1, 0, "tui-scroll-controls", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showScrollbars);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiScrollControlsComponent], styles: ["[_nghost-%COMP%]{z-index:0;position:relative;display:flex;overflow:auto}[_nghost-%COMP%]:not(._legacy){scrollbar-width:none;-ms-overflow-style:none}[_nghost-%COMP%]:not(._legacy)::-webkit-scrollbar, [_nghost-%COMP%]:not(._legacy)::-webkit-scrollbar-thumb{background:0 0;width:0;height:0}._legacy[_nghost-%COMP%]{overflow:overlay}@media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution:0.001dpcm){._legacy[_nghost-%COMP%]::-webkit-scrollbar, ._legacy[_nghost-%COMP%]::-webkit-scrollbar-thumb{width:1rem;height:1rem;border-radius:6.25rem;background-clip:padding-box;border:6px solid transparent}._legacy[_nghost-%COMP%]::-webkit-scrollbar{background-color:transparent}._legacy[_nghost-%COMP%]::-webkit-scrollbar-thumb{background-color:var(--tui-clear-hover)}._legacy[_nghost-%COMP%]::-webkit-scrollbar-thumb:hover{background-color:var(--tui-clear-active)}._legacy[_nghost-%COMP%]::-webkit-scrollbar-thumb:active{background-color:var(--tui-text-03)}}.content[_ngcontent-%COMP%]{position:relative;z-index:0;flex:1;flex-basis:auto;width:100%;height:-webkit-max-content;height:-moz-max-content;height:max-content}"], changeDetection: 0 });
TuiScrollbarComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CSS,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: String, decorators: [{ type: Inject, args: [USER_AGENT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiScrollbarComponent.prototype, "hidden", void 0);
__decorate([
    HostBinding('class._legacy')
], TuiScrollbarComponent.prototype, "showNative", null);
__decorate([
    HostListener(`${TUI_SCROLLABLE}.stop`, ['$event.detail'])
], TuiScrollbarComponent.prototype, "onScrollable", null);
__decorate([
    HostListener(`${TUI_SCROLL_INTO_VIEW}.stop`, ['$event.detail'])
], TuiScrollbarComponent.prototype, "scrollIntoView", null);
TuiScrollbarComponent = TuiScrollbarComponent_1 = __decorate([ __param(0, Inject(CSS)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(USER_AGENT)),
    __param(3, Inject(TUI_IS_IOS))
], TuiScrollbarComponent);

let TuiScrollbarModule = class TuiScrollbarModule {
};
TuiScrollbarModule.ɵfac = function TuiScrollbarModule_Factory(t) { return new (t || TuiScrollbarModule)(); };
TuiScrollbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiScrollbarModule });
TuiScrollbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiScrollControlsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiScrollRefDirective, [{
        type: Directive,
        args: [{
                selector: SCROLL_REF_SELECTOR,
                providers: [
                    {
                        provide: TUI_SCROLL_REF,
                        useExisting: ElementRef
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiScrollableDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiScrollable]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiScrollbarComponent, [{
        type: Component,
        args: [{
                selector: 'tui-scrollbar',
                template: "<tui-scroll-controls *ngIf=\"showScrollbars\"></tui-scroll-controls>\n<div class=\"content\">\n    <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_SCROLL_REF,
                        deps: [TuiScrollbarComponent_1],
                        useFactory: scrollRefFactory
                    },
                ],
                styles: [":host{z-index:0;position:relative;display:flex;overflow:auto}:host:not(._legacy){scrollbar-width:none;-ms-overflow-style:none}:host:not(._legacy)::-webkit-scrollbar,:host:not(._legacy)::-webkit-scrollbar-thumb{background:0 0;width:0;height:0}:host._legacy{overflow:overlay}@media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution:0.001dpcm){:host._legacy::-webkit-scrollbar,:host._legacy::-webkit-scrollbar-thumb{width:1rem;height:1rem;border-radius:6.25rem;background-clip:padding-box;border:6px solid transparent}:host._legacy::-webkit-scrollbar{background-color:transparent}:host._legacy::-webkit-scrollbar-thumb{background-color:var(--tui-clear-hover)}:host._legacy::-webkit-scrollbar-thumb:hover{background-color:var(--tui-clear-active)}:host._legacy::-webkit-scrollbar-thumb:active{background-color:var(--tui-text-03)}}.content{position:relative;z-index:0;flex:1;flex-basis:auto;width:100%;height:-webkit-max-content;height:-moz-max-content;height:max-content}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [CSS]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [USER_AGENT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }]; }, { hidden: [{
            type: Input
        }], showNative: [{
            type: HostBinding,
            args: ['class._legacy']
        }], onScrollable: [{
            type: HostListener,
            args: [`${TUI_SCROLLABLE}.stop`, ['$event.detail']]
        }], scrollIntoView: [{
            type: HostListener,
            args: [`${TUI_SCROLL_INTO_VIEW}.stop`, ['$event.detail']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiScrollbarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiScrollControlsModule],
                declarations: [TuiScrollbarComponent, TuiScrollRefDirective, TuiScrollableDirective],
                exports: [TuiScrollbarComponent, TuiScrollRefDirective, TuiScrollableDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiScrollbarModule, { declarations: function () { return [TuiScrollbarComponent, TuiScrollRefDirective, TuiScrollableDirective]; }, imports: function () { return [CommonModule, TuiScrollControlsModule]; }, exports: function () { return [TuiScrollbarComponent, TuiScrollRefDirective, TuiScrollableDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SCROLL_REF_SELECTOR, TuiScrollRefDirective, TuiScrollableDirective, TuiScrollbarComponent, TuiScrollbarModule, scrollRefFactory };

